function Certs() {
    return (
      <>
        <h2>Certifications</h2>
        <ul>
          <li>Corporate Finance Institute</li>
          <ul>
            <li>
              Capital Markets & Securities Analyst <em>(September 2024)</em>
            </li>
            <li>
              Business Intelligence & Data Analyst <em>(In progress)</em>
            </li>
          </ul>
          <li>Coursera</li>
          <ul>
            <li>
              Google Data Analytics Professional Certificate <em>(May 2023)</em>
            </li>
            <li>
              Google UX Design Professional Certificate <em>(June 2022)</em>
            </li>
          </ul>
        </ul>
      </>
    );
}

export default Certs;